import { render, staticRenderFns } from "./VwcTextField.vue?vue&type=template&id=0bcb524a&scoped=true&"
import script from "./VwcTextField.vue?vue&type=script&lang=js&"
export * from "./VwcTextField.vue?vue&type=script&lang=js&"
import style0 from "./VwcTextField.vue?vue&type=style&index=0&id=0bcb524a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb524a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcb524a')) {
      api.createRecord('0bcb524a', component.options)
    } else {
      api.reload('0bcb524a', component.options)
    }
    module.hot.accept("./VwcTextField.vue?vue&type=template&id=0bcb524a&scoped=true&", function () {
      api.rerender('0bcb524a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VwcTextField.vue"
export default component.exports